import firebase from "firebase";

const firebaseApp = firebase.initializeApp({

    apiKey: "AIzaSyBk5R_5GmvZHXtznBkgiXb4G4gCncG2_UE",
    authDomain: "current-news-chat.firebaseapp.com",
    projectId: "current-news-chat",
    storageBucket: "current-news-chat.appspot.com",
    messagingSenderId: "67002638878",
    appId: "1:67002638878:web:6e396a515742116239840f",
    measurementId: "G-192QGQHYJR"

});

const db = firebaseApp.firestore();

export default db;